import React, { useContext, Fragment } from 'react';
import ReactPlaceholder from 'react-placeholder';
import { Field } from 'formik';
import { Row, Subtext, Form, InputPlaceholder } from '@contently/toolkit';
import { FormikHandlersContext } from './DynamicFormikForm';
import CheckboxSection from '../checkboxes/checkbox_section';
import formatOptions from '../../../utils/formatters/formatOptions';

function BasicCheckboxGroup(props) {
  const {
    errors,
    id,
    label,
    name,
    optionsAccessor,
    placeholder,
    record,
    // renderSubtext,
    required,
    subtext,
    touched,
    type,
    validate,
    value
  } = props;

  const { setFieldValue, isFetching } = useContext(FormikHandlersContext);
  const renderSubtext = () => (typeof subtext === 'string' ? subtext : subtext());

  const handleChange = data => {
    setFieldValue(id, data.filter(opt => opt.checked).map(opt => opt.value));
  };

  const options = formatOptions(optionsAccessor(record)).map(opt => {
    return { ...opt, checked: value.includes(opt.value) };
  });

  const validation = input => {
    if (required) {
      if (!value || !value.length) {
        return 'At least one option must be selected';
      }
    }
    if (validate) {
      return validate(input);
    }
    return undefined;
  };

  return (
    <Row>
      <ReactPlaceholder
        showLoadingAnimation
        customPlaceholder={<InputPlaceholder wrapperClass="row" withLabel />}
        ready={!isFetching}
      >
        <Form.Label required htmlFor={id}>
          {label}
        </Form.Label>
        {subtext && <Subtext>{renderSubtext()}</Subtext>}
        <Field name={id} validate={validation}>
          {({ field, _form }) => (
            <Fragment>
              <Form.ErrorWrapper touched={touched} error={errors}>
                <CheckboxSection onChange={handleChange} options={options} id={id} noTranslate />
              </Form.ErrorWrapper>
            </Fragment>
          )}
        </Field>
      </ReactPlaceholder>
    </Row>
  );
}

export default BasicCheckboxGroup;



// WEBPACK FOOTER //
// ./app/javascript/app/components/forms/dynamic_forms/BasicCheckboxGroup.jsx